let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 课程列表筛选项
  getParams: `${baseUrl}/course/optional/parameter`,
  // 课程列表
  getCourseList: `${baseUrl}/course/aiclassType/study/list`,
  // 小组列表
  getGroupList: `${baseUrl}/course/mygroup`,
  // 教师列表查询
  getTeacherList: `${baseUrl}/base/getUserListPage`,
  // 获取学生列表
  getStudentList: `${baseUrl}/base/insStudentList`,
  // 年级列表
  getGradeList: `${baseUrl}/base/studentInstitutionGradeList`,
  // 新建小组
  createGroup: `${baseUrl}/course/create/group`,
  // 编辑小组
  editGroup: `${baseUrl}/course/update/group`,
  // 获取小组下已选学生
  getSelectedStudentList: `${baseUrl}/course/intragroup/student`,
  // 获取学习机课程列表
  getCourseListByName: `${baseUrl}/course/xkhpad/query`,
  // 检查课程下小组成员冲突列表
  // checkStudentConflict: `${baseUrl}/course/conflict/stulist`
  // 检查课程下小组成员冲突列表(新接口，添加小组和编辑小组都使用)https://yapi.aixuexi.com/project/42/interface/api/182075
  checkStudentConflict: `${baseUrl}/base/insStudentList`,
  adminCourseMaterials: classTypeId => `${baseUrl}/classtype/resource/${classTypeId}`,
  // 获取AI课程片段 https://yapi.aixuexi.com/project/42/interface/api/197768
  findCourseware: ({ classTypeId, lessonId }) => `${baseUrl}/course/lesson/findCourseware/${classTypeId}/${lessonId}`
}
